export const setLocalStorage = value => window.localStorage.setItem('session', JSON.stringify(value))

export const getLocalStorage = initialValue => {
  const value = window.localStorage.getItem('session')
  return value ? JSON.parse(value) : initialValue
}
